<template>
    <div>
        <h3>Fix Experiments</h3>
        <el-form :model="item" label-width="120px" label-position="left">
            <el-form-item label="Commit SHA" required>
                <el-input v-model="item.sha" :disabled="item.id">
                    <el-button slot="append" type="primary" @click="deployFix" v-loading="loading.hotfix">
                        Deploy fix
                    </el-button>
                </el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { defaultHotfixItem } from '../constants';

export default {
    name: 'hotfix',
    data() {
        return {
            item: Object.assign({}, defaultHotfixItem),
        };
    },
    computed: {
        ...mapGetters(['loading']),
    },
    methods: {
        ...mapMutations(['setLoading', 'unsetLoading']),
        async deployFix() {
            if (!this.item.sha) {
                return this.$message.error('Please provide SHA');
            }

            try {
                this.setLoading('hotfix');

                await this.$api.post('/product/experiments/hotfix', this.item);

                this.$notify.success({
                    title: 'Fixes deployed successfully',
                    message: 'Go to experiments section in order to upload changes'
                });
            } catch (e) {
                const message = e.response?.data.error || e.request || e.message;
                const title = 'Failed deploying hotfix for experiment';

                this.$alert(message, title, { confirmButtonText: 'OK' });
            } finally {
                this.unsetLoading('hotfix');
            }
        }
    },
}
</script>
